import { IMessageType } from '@/services/signalr/types';
import { IStatusMsg } from '~/api/messages/IStatusMsg';
import { ITripUpdateMsg } from '~/api/messages/ITripUpdateMsg';

export const TripUpdateReq: IMessageType<ITripUpdateMsg, IStatusMsg> = {
  hybridRequestName: 'TripUpdateMsg',
  requestName: 'TripUpdateReqMsg',
  responseName: 'StatusMsg',
};

export const PatientTripUpdateReq: IMessageType<ITripUpdateMsg> = {
  requestName: 'TripUpdateReqMsg',
};

export const ReturnTripUpdateReq: IMessageType<ITripUpdateMsg> = {
  requestName: 'TripUpdateReqMsg',
};
